export default __webpack_public_path__ + "static/media/MexicoMuseums.21e41232.webp";